import { i18n } from '../../i18n/i18n.js'

/**
 * 邮箱留资弹窗组件
 * 用户点击预约后显示表单，收集姓名、邮箱、电话、需求描述
 */
export class LeadFormModal {
  constructor(options = {}) {
    this.analysisData = options.analysisData || null
    this.onSubmit = options.onSubmit || (() => {})
    this.onClose = options.onClose || (() => {})
    this.element = null
    this.backdrop = null
    this.isOpen = false
  }

  open() {
    if (this.isOpen) return

    this._createBackdrop()
    this._createModal()
    this._bindEvents()

    document.body.appendChild(this.backdrop)
    document.body.appendChild(this.element)

    this.isOpen = true

    requestAnimationFrame(() => {
      if (this.backdrop) this.backdrop.classList.add('visible')
      if (this.element) this.element.classList.add('visible')
    })
  }

  close() {
    if (!this.isOpen) return

    if (this.backdrop) this.backdrop.classList.remove('visible')
    if (this.element) this.element.classList.remove('visible')

    setTimeout(() => {
      this._destroy()
    }, 300)

    this.isOpen = false
    this.onClose()
  }

  _createBackdrop() {
    this.backdrop = document.createElement('div')
    this.backdrop.className = 'lead-modal-backdrop'
  }

  _createModal() {
    this.element = document.createElement('div')
    this.element.className = 'lead-modal'
    this.element.setAttribute('role', 'dialog')
    this.element.setAttribute('aria-modal', 'true')
    this.element.setAttribute('aria-label', i18n.t('consultation.modalTitle'))

    const regionName = this.analysisData?.analysisResult?.subzone?.nameZh || ''
    const nodeName = this.analysisData?.analysisResult?.nearestNode?.node?.nameZh || ''
    const coords = this.analysisData?.analysisResult?.selectedPoint
      ? `${this.analysisData.analysisResult.selectedPoint.lat.toFixed(4)}, ${this.analysisData.analysisResult.selectedPoint.lng.toFixed(4)}`
      : ''

    this.element.innerHTML = `
      <div class="lead-modal-header">
        <h3 class="lead-modal-title">${i18n.t('consultation.modalTitle')}</h3>
        <button type="button" class="lead-modal-close" aria-label="${i18n.t('common.close')}">×</button>
      </div>
      <div class="lead-modal-body">
        <form class="lead-form">
          <div class="lead-form-group">
            <label for="lead-name">${i18n.t('consultation.form.nameLabel')} *</label>
            <input type="text" id="lead-name" name="name" required placeholder="${i18n.t('consultation.form.nameLabel')}">
          </div>
          <div class="lead-form-group">
            <label for="lead-email">${i18n.t('consultation.form.emailLabel')} *</label>
            <input type="email" id="lead-email" name="email" required placeholder="${i18n.t('consultation.form.emailLabel')}">
          </div>
          <div class="lead-form-group">
            <label for="lead-phone">${i18n.t('consultation.form.phoneLabel')}</label>
            <input type="tel" id="lead-phone" name="phone" placeholder="${i18n.t('consultation.form.phoneLabel')}">
          </div>
          <div class="lead-form-group">
            <label for="lead-message">${i18n.t('consultation.form.messageLabel')}</label>
            <textarea id="lead-message" name="message" rows="3" placeholder="${i18n.t('consultation.form.messageLabel')}"></textarea>
          </div>
          <div class="lead-form-meta">
            <p><strong>分析位置：</strong>${regionName || '未选择区域'} ${nodeName ? `(${nodeName})` : ''}</p>
            ${coords ? `<p><strong>坐标：</strong>${coords}</p>` : ''}
          </div>
          <button type="submit" class="lead-submit-btn">${i18n.t('consultation.form.submitButton')}</button>
        </form>
      </div>
    `
  }

  _bindEvents() {
    const closeBtn = this.element.querySelector('.lead-modal-close')
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close())
    }

    this.backdrop.addEventListener('click', () => this.close())

    this._handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        this.close()
      }
    }
    document.addEventListener('keydown', this._handleKeyDown)

    const form = this.element.querySelector('.lead-form')
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault()
        this._handleSubmit(form)
      })
    }
  }

  _handleSubmit(form) {
    const formData = new FormData(form)
    const data = {
      name: formData.get('name')?.trim() || '',
      email: formData.get('email')?.trim() || '',
      phone: formData.get('phone')?.trim() || '',
      message: formData.get('message')?.trim() || '',
      region: this.analysisData?.analysisResult?.subzone?.nameZh || '',
      node: this.analysisData?.analysisResult?.nearestNode?.node?.nameZh || '',
      coordinates: this.analysisData?.analysisResult?.selectedPoint || null,
      submittedAt: new Date().toISOString()
    }

    this.onSubmit(data)

    this._showSuccess()
  }

  _showSuccess() {
    const body = this.element.querySelector('.lead-modal-body')
    if (!body) return

    body.innerHTML = `
      <div class="lead-success">
        <div class="lead-success-icon">✓</div>
        <h4>${i18n.t('consultation.form.successMessage')}</h4>
        <button type="button" class="lead-submit-btn" data-action="close">${i18n.t('common.close')}</button>
      </div>
    `

    const closeBtn = body.querySelector('[data-action="close"]')
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close())
    }
  }

  _destroy() {
    if (this.backdrop) {
      this.backdrop.remove()
      this.backdrop = null
    }

    if (this.element) {
      this.element.remove()
      this.element = null
    }

    if (this._handleKeyDown) {
      document.removeEventListener('keydown', this._handleKeyDown)
      this._handleKeyDown = null
    }
  }
}
